import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { CURRENCIES, useCurrencyStore } from '@/stores/currencyStore';

export const CurrencySelector: React.FC = () => {
  const { selectedCurrency, setSelectedCurrency } = useCurrencyStore();

  return (
    <Select
      value={selectedCurrency.code}
      onValueChange={(code) => {
        const currency = CURRENCIES.find(c => c.code === code);
        if (currency) setSelectedCurrency(currency);
      }}
    >
      <SelectTrigger className="w-[90px] h-8 text-xs">
        <SelectValue placeholder="Currency">
          {selectedCurrency.symbol} {selectedCurrency.code}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {CURRENCIES.map((currency) => (
          <SelectItem key={currency.code} value={currency.code}>
            {currency.symbol} {currency.code} - {currency.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
